function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Template"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59,2H5A3,3,0,0,0,2,5V59a3,3,0,0,0,3,3H59a3,3,0,0,0,3-3V5A3,3,0,0,0,59,2ZM4,5A1,1,0,0,1,5,4H59a1,1,0,0,1,1,1v9H4ZM60,59a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V16H60Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55,12H31a3,3,0,0,1,0-6H55a3,3,0,0,1,0,6ZM31,8a1,1,0,0,0,0,2H55a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,12a3,3,0,1,1,3-3A3,3,0,0,1,9,12ZM9,8a1,1,0,1,0,1,1A1,1,0,0,0,9,8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,12a3,3,0,1,1,3-3A3,3,0,0,1,16,12Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,16,8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23,12a3,3,0,1,1,3-3A3,3,0,0,1,23,12Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,23,8Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27,34H11a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1V33A1,1,0,0,1,27,34ZM12,32H26V22H12Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53,24H33a1,1,0,0,1,0-2H53a1,1,0,0,1,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53,28H33a1,1,0,0,1,0-2H53a1,1,0,0,1,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53,32H33a1,1,0,0,1,0-2H53a1,1,0,0,1,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53,42H43a1,1,0,0,1-1-1V37a1,1,0,0,1,1-1H53a1,1,0,0,1,1,1v4A1,1,0,0,1,53,42Zm-9-2h8V38H44Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21,42H11a1,1,0,0,1-1-1V37a1,1,0,0,1,1-1H21a1,1,0,0,1,1,1v4A1,1,0,0,1,21,42Zm-9-2h8V38H12Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37,42H27a1,1,0,0,1-1-1V37a1,1,0,0,1,1-1H37a1,1,0,0,1,1,1v4A1,1,0,0,1,37,42Zm-9-2h8V38H28Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53,56H11a1,1,0,0,1-1-1V45a1,1,0,0,1,1-1H53a1,1,0,0,1,1,1V55A1,1,0,0,1,53,56ZM12,54H52V46H12Z"
}));

var SvgTemplate = function SvgTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template.1fa66f17.svg";
export { ForwardRef as ReactComponent };